import { Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'lib-web-shared-ui-404-page-not-found',
  imports: [MatButtonModule],
  templateUrl: './lib-404-page-not-found.component.html',
  styleUrl: './lib-404-page-not-found.component.scss',
})
export class Lib404PageNotFoundComponent implements OnInit {
  private router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    // Log 404 page access for server-side monitoring
    if (isPlatformServer(this.platformId)) {
      console.log('404 - Page not found accessed on server-side rendering');
    } else {
      console.log('404 - Page not found accessed on client-side');
    }
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
